<div class="gl-page">
  <!-- Back link -->
  <yds-button-back
    text="Ga terug 'Loonjournaal voor grootboeksysteem - Loonjournaal selecteren'"
    (back)="goBack()"
  />

  <!-- Title -->
  <div class="gl-page__header">
    <h1 class="gl-page__title">Maak journalisering voor grootboeksysteem</h1>
  </div>

  <yds-card-editable
    title="Details"
    [(editing)]="detailsEditing"
    [cancelLabel]="'Annuleren'"
    [nextLabel]="'Starten export'"
    [nextDisabled]="isSaving() || form.invalid"
    (cancel)="onCancel()"
    (next)="onStartExport()"
  >
    @if (isSaving()) {
      <div class="gl-detail-loading">
        <yds-spinner [label]="'Export starten...'" />
      </div>
    } @else if (detailsEditing()) {
    <form class="gl-form" [formGroup]="form">
      <p class="gl-form__required-hint">
        Velden gemarkeerd met een sterretje
        (<span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>) zijn verplicht.
      </p>

      <div class="gl-field">
        <label class="gl-field__label" [attr.for]="instellingField.inputId">Instelling</label>
        <div class="gl-field__control">
          <yds-text-field #instellingField [readonly]="true" [value]="instellingName()" />
        </div>
      </div>

      <div class="gl-field">
        <label class="gl-field__label" [attr.for]="periodeField.inputId">Periode</label>
        <div class="gl-field__control">
          <yds-text-field #periodeField [readonly]="true" [value]="periode()" />
        </div>
      </div>

      <div class="gl-field">
        <label class="gl-field__label" id="cgl-bookinggroup-label">
          <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Boekingsgroep
        </label>
        <div class="gl-field__control">
          <yds-dropdown
            [items]="bookingGroupOptions()"
            formControlName="bookingGroupId"
            [allowClear]="false"
            [required]="true"
            ariaLabelledby="cgl-bookinggroup-label"
            [hasError]="isInvalid(form.get('bookingGroupId'))"
            [errorMsg]="'Boekingsgroep is verplicht.'"
          />
        </div>
      </div>

      <div class="gl-field">
        <label class="gl-field__label" id="cgl-processdefinition-label">
          <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>
          Verwerkingsdefinitie
        </label>
        <div class="gl-field__control">
          <yds-dropdown
            [items]="journalProcessDefinitionOptions()"
            formControlName="journalProcessDefinitionId"
            [allowClear]="false"
            [required]="true"
            ariaLabelledby="cgl-processdefinition-label"
            [disabled]="isLoadingDefinitions()"
            [hasError]="isInvalid(form.get('journalProcessDefinitionId'))"
            [errorMsg]="'Verwerkingsdefinitie is verplicht.'"
          />
        </div>
      </div>

      <div class="gl-field">
        <label class="gl-field__label" [attr.for]="soortField.inputId">
            <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>
            Soort journalisering
        </label>
        <div class="gl-field__control">
          <yds-text-field #soortField [readonly]="true" [value]="soortJournalisering" />
        </div>
      </div>

      <div class="gl-field">
        <label class="gl-field__label" id="cgl-exportdefinition-label">
          <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Exportdefinitie
        </label>
        <div class="gl-field__control">
          <yds-dropdown
            [items]="exportDefinitionOptions()"
            formControlName="exportDefinitionId"
            [allowClear]="false"
            [required]="true"
            ariaLabelledby="cgl-exportdefinition-label"
            [hasError]="isInvalid(form.get('exportDefinitionId'))"
            [errorMsg]="'Exportdefinitie is verplicht.'"
          />
        </div>
      </div>

      <div class="gl-field">
        <label class="gl-field__label" id="cgl-verzending-label">
          <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>
          Verzending definitieve journaalposten
        </label>
        <div class="gl-field__control">
          <yds-dropdown
            [items]="verzendingOptions"
            formControlName="verzending"
            [allowClear]="false"
            [required]="true"
            ariaLabelledby="cgl-verzending-label"
            [hasError]="isInvalid(form.get('verzending'))"
            [errorMsg]="'Verzending definitieve journaalposten is verplicht.'"
          />
        </div>
      </div>
    </form>
    } @else {
      <div class="gl-detail">
        <div class="gl-detail__row">
          <span class="gl-detail__label">Instelling</span>
          <span class="gl-detail__value">{{ instellingName() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Periode</span>
          <span class="gl-detail__value">{{ periode() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Boekingsgroep</span>
          <span class="gl-detail__value">{{ selectedBookingGroupName() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Verwerkingsdefinitie</span>
          <span class="gl-detail__value">{{ selectedJournalProcessDefinitionName() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Soort journalisering</span>
          <span class="gl-detail__value">{{ soortJournalisering }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Exportdefinitie</span>
          <span class="gl-detail__value">{{ selectedExportDefinitionName() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Verzending definitieve journaalposten</span>
          @if (exportFailed()) {
            <span class="gl-detail__value cgl-error" role="alert">
              Grootboek export aanmaken mislukt
              @if (exportErrorMessage()) {
                <span class="cgl-error__detail">{{ exportErrorMessage() }}</span>
              }
            </span>
          } @else if (exportDone()) {
            @if (isFileApiSend()) {
              <span class="gl-detail__value">File verstuurd via File-API</span>
            } @else {
              <span class="gl-detail__value cgl-pending">
                <a href="#" (click)="onDownload($event)">{{ selectedVerzendingName() }}</a>
                @if (isDownloading()) {
                  <yds-spinner size="sm" [label]="'Export downloaden...'" />
                }
              </span>
              @if (downloadError()) {
                <span class="gl-detail__value cgl-error" role="alert">{{ downloadError() }}</span>
              }
            }
          } @else {
            <span class="gl-detail__value cgl-pending">
              <span>{{ selectedVerzendingName() }}</span>
              <yds-spinner size="sm" [label]="'Export wordt aangemaakt...'" />
            </span>
          }
        </div>
      </div>
    }

    @if (startError()) {
      <p cardFooterMessage class="cgl-error cgl-error--footer" role="alert">{{ startError() }}</p>
    }
  </yds-card-editable>

</div>
